import { NgModule } from '@angular/core';
import { PagesComponent } from './pages.component';
import { RouterModule, Routes } from '@angular/router';
import { PageNotFoundComponent } from './page-not-found/page-not-found.component';
import { UnauthorizedComponent } from './unauthorized/unauthorized.component';
import { IntroComponent } from './intro/intro.component';
import { MedicareApplicationComponent } from '@pages/medicare-application/medicare-application.component';
import { ConfirmationComponent } from '@pages/confirmation/confirmation.component';
import { ApplicationStatusCompletedGuardFn } from '@core/guards/application-status-completed.guard';
import { OktaAuthGuardFn } from '@core/guards/okta-auth.guard';
import { MedicareUserGuardFn } from '@core/guards/medicare-user.guard';
import { ApplicationStatusNewGuardFn } from '@core/guards/application-status-new.guard';
import { BlueButtonComponent } from '@pages/blue-button/blue-button.component';
import { DashboardComponent } from '@pages/dashboard/dashboard.component';
import { ApplicationIntroGuardFn } from '@core/guards/application-intro.guard';
import { LanguageSelectionComponent } from './language-selection/language-selection.component';

const AUTH_GUARDS = [OktaAuthGuardFn, MedicareUserGuardFn];

const routes: Routes = [
  {
    path: '',
    component: LanguageSelectionComponent,
    canActivate: [...AUTH_GUARDS],
  },
  {
    path: 'dashboard',
    component: DashboardComponent,
    canActivate: [...AUTH_GUARDS],
  },
  {
    path: 'intro',
    component: IntroComponent,
    canActivate: [...AUTH_GUARDS, ApplicationIntroGuardFn],
  },
  {
    path: 'application',
    component: MedicareApplicationComponent,
    // resolve: { new resolver },
    canActivate: [...AUTH_GUARDS],
    loadChildren: () => import('./medicare-application/medicare-application.module')
      .then(m => m.MedicareApplicationModule),
  },

  {
    path: 'confirmation/:applicationId',
    component: ConfirmationComponent,
    canActivate: [...AUTH_GUARDS, ApplicationStatusCompletedGuardFn],
  },
  {
    path: 'blue-button-cms',
    component: BlueButtonComponent,
  },
  {path: 'page-not-found', component: PageNotFoundComponent},
  {path: 'session-expired', component: UnauthorizedComponent},
  {path: '', redirectTo: '', pathMatch: 'full'},
  {path: '**', redirectTo: 'page-not-found'},
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class PagesRoutingModule {
}

export const routedComponents = [
  PagesComponent,
  BlueButtonComponent,
  ConfirmationComponent,
  PageNotFoundComponent,
  UnauthorizedComponent,
  IntroComponent,
  DashboardComponent,
  LanguageSelectionComponent,
];

export const routerProviders = [
  ApplicationStatusCompletedGuardFn,
  ApplicationIntroGuardFn,
  ApplicationStatusNewGuardFn,
  OktaAuthGuardFn,
  MedicareUserGuardFn,
];
